import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3402';

export interface ImpersonationLog {
  id: string;
  adminId: string;
  targetUserId: string;
  reason: string;
  ipAddress?: string;
  startedAt: Date;
  endedAt?: Date;
  actionsPerformed?: any[];
  createdAt: Date;
  updatedAt: Date;
  admin?: {
    id: string;
    username: string;
    displayName: string;
    email: string;
  };
  targetUser?: {
    id: string;
    username: string;
    displayName: string;
    email: string;
  };
}

export interface StartImpersonationData {
  targetUserId: string;
  reason: string;
}

const impersonationService = {
  // Start impersonation session
  start: async (data: StartImpersonationData): Promise<{ token: string; sessionId: string }> => {
    const response = await axios.post(`${API_URL}/api/admin/impersonation/start`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // End impersonation session
  end: async (sessionId: string): Promise<void> => {
    await axios.post(
      `${API_URL}/api/admin/impersonation/end`,
      { sessionId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
  },

  // Get all impersonation logs
  getLogs: async (params?: {
    adminId?: string;
    targetUserId?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<ImpersonationLog[]> => {
    const response = await axios.get(`${API_URL}/api/admin/impersonation/logs`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get active sessions
  getActiveSessions: async (): Promise<ImpersonationLog[]> => {
    const response = await axios.get(`${API_URL}/api/admin/impersonation/active`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get single log
  getLog: async (id: string): Promise<ImpersonationLog> => {
    const response = await axios.get(`${API_URL}/api/admin/impersonation/logs/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },
};

export default impersonationService;
